/**
 * @generated SignedSource<<129a2122aac2bf514a46d26edfc7a7c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MemberOnboardingBannerRefetchableFragment_usage$data = {
  readonly id: string;
  readonly viewerHasCompleted: boolean;
  readonly " $fragmentType": "MemberOnboardingBannerRefetchableFragment_usage";
};
export type MemberOnboardingBannerRefetchableFragment_usage$key = {
  readonly " $data"?: MemberOnboardingBannerRefetchableFragment_usage$data;
  readonly " $fragmentSpreads": FragmentRefs<"MemberOnboardingBannerRefetchableFragment_usage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./MemberOnboardingBannerRefetchQuery.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "MemberOnboardingBannerRefetchableFragment_usage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerHasCompleted",
      "storageKey": null
    }
  ],
  "type": "ContentUsage",
  "abstractKey": null
};

(node as any).hash = "41cb3bc8cd64eaf817b62c2db4775deb";

export default node;
